module.exports = __webpack_public_path__ + "static/media/group-9@2x.8c4e7751.png";